import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState } from 'react';
import LoginForm from '@widgets/LoginForm';
import ForgotPasswordForm from '@widgets/ForgotPassword';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import useDidMount from 'beautiful-react-hooks/useDidMount';
import { useEffect } from 'preact/compat';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import { Wrapper } from './styles';
function Modal(props) {
    const { login, forgotPassword } = props;
    const [status, setStatus] = useState('login');
    return (_jsxs(Wrapper, { className: "primary-modal-content", children: [status === 'login' && (_jsx("div", { className: "form", children: _jsx("div", { className: "form__content", children: _jsx(LoginForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        dataset: { ...login }, onHandleForgotPassword: () => setStatus('forgot-password') }) }) })), status === 'forgot-password' && (_jsx(ForgotPasswordForm, { dataset: { ...forgotPassword, onSuccessButtonClick: undefined }, onSuccessButtonClick: () => {
                    setStatus('login');
                } }))] }));
}
export default function LoginModal(props) {
    const { dataset } = props;
    const [refresh, setRefresh] = useState(false);
    const modalConfig = convertDataAttributes(dataset ?? {});
    useDidMount();
    const onHandleLoginClosed = useGlobalEvent('login.closed');
    onHandleLoginClosed(() => {
        setRefresh(true);
    });
    // probably quite hacky. Refresh, refresh the modal after 1 millisecond so data refreshed on close.
    useEffect(() => {
        if (refresh) {
            setTimeout(() => {
                setRefresh(false);
            }, 1);
        }
    }, [refresh]);
    if (!refresh) {
        return (_jsx(Modal, { ...modalConfig }));
    }
    return null;
}
